const technicalSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Overview of Coding Interviews</h3>
      <ul className="list-disc pl-6">
        <li>
          Coding interviews are a common method for assessing software engineering candidates.
        </li>
        <li>
          They typically last 45-60 minutes and involve solving 1-2 programming problems in a live
          coding environment.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Common Interview Questions</h3>
      <ul className="list-disc pl-6">
        <li>
          Questions may involve writing functions to solve problems like reversing a string or
          checking for palindromes.
        </li>
        <li>Problems can range from simple to highly complex.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Evaluation Criteria</h3>
      <ul className="list-disc pl-6">
        <li>
          <strong>Communication:</strong> Clearly explaining your approach and asking clarifying
          questions.
        </li>
        <li>
          <strong>Problem-Solving:</strong> Exploring multiple solutions and optimizing for
          efficiency.
        </li>
        <li>
          <strong>Technical Competency:</strong> Writing correct and clean code.
        </li>
        <li>
          <strong>Testing:</strong> Verifying solutions against normal and edge cases.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Effective Preparation Strategies</h3>
      <ul className="list-disc pl-6">
        <li>Practice is the best way to prepare for coding interviews.</li>
        <li>
          LeetCode is a widely used platform for practicing common technical interview questions.
        </li>
        <li>Structured problem-solving practice helps build confidence and readiness.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Building Confidence</h3>
      <ul className="list-disc pl-6">
        <li>Different experience levels require different preparation approaches.</li>
        <li>Consistent practice leads to better performance and increased confidence.</li>
      </ul>
    </div>
  </div>
);

export default technicalSummary;
